import { Surface } from '@cfa/react-components';

import { cn } from '@/utils/tailwind';

interface BackToTopCircleProps {
  className?: string;
  onClick?: () => void;
  children?: React.ReactNode;
}

export const BackToTopCircle: React.FC<BackToTopCircleProps> = ({
  className,
  onClick,
  children,
  ...props
}) => (
  <Surface
    {...props}
    onClick={onClick}
    className={cn(
      'shadow-elevation-4! fixed! right-5! bottom-4! z-4! flex! size-11! cursor-pointer! items-center! justify-center! rounded-full! border-2! border-white! bg-[#ECF7F9]!',
      className,
    )}
  >
    {children}
  </Surface>
);
